module.exports = __webpack_public_path__ + "img/7.db4fe911.png";